import React from 'react'
import Clients from './Clients'
import { NavLink } from "react-router-dom"

/**
  * @class Footer
  * calls Clients component
*/
class Footer extends React.Component {
  goTop = () => {
    window.scrollTo(0,0)
  }

  render() {
    return (
      <React.Fragment>
        <Clients/>
        <footer className="bg--black">
          <div className="container primary-footer">
            <div className="row">
              <div className="col-md col-xs-8 offset-xs-2 footer__border">
                <img src="/images/logos/cosmic.png" alt="Cosmic - Altavia Group" />
              </div>
              <div className="col-md col-xs-8 offset-xs-2 footer__border">
                <h2>Nous sommes ici</h2>
                <p>2 Place du Colonel Fabien<br/> 75019 Paris</p>
                <h2>Échangeons</h2>
                <img src="/images/contact-bonjour.png" alt="Bonjour" /><br/>
                T / +33 (0) 1 44 58 58 58<br/>
                <img src="/images/contact-talents.png" alt="Talents" />
              </div>
              <div className="col-md col-xs-2 offset-xs-5">
                <h2>Consortium</h2>
                <a href="http://www.altavia-pallas.com/" target="_blank" rel="noopener noreferrer">
                  <img className="footer__logo" src="/images/logos/altavia-pallas.png" alt="Altavia Pallas, concepteur de commerces - Altavia Group" />
                </a>
                <a href="https://www.altavia-retailtech.io" target="_blank" rel="noopener noreferrer">
                  <img className="footer__logo" src="/images/logos/altavia-retailtech.png" alt="Altavia RetailTech - Altavia Group" />
                </a>
                <a href="http://www.shoppermind.com/" target="_blank" rel="noopener noreferrer">
                  <img className="footer__logo" src="/images/logos/shoppermind.png" alt="Shoppermind - Altavia Group" />
                </a>
                <a href="http://www.insitaction.com/" target="_blank" rel="noopener noreferrer">
                  <img className="footer__logo" src="/images/logos/insitaction.png" alt="Insitaction - Altavia Group" />
                </a>
              </div>
              <div className="col-md col-xs-8 offset-xs-2">
                <h2>Altavia group</h2>
                <a href="https://www.altavia-group.com" target="_blank" rel="noopener noreferrer">
                  <img className="footer__logo" src="/images/logos/altavia.png" alt="Altavia Group" />
                </a>
              </div>
            </div>
          </div>
          <div className="container-fluid bg--lightgrey center-text secondary-footer">
            <div className="row">
              <div className="col">
                <p>© 2018 Agence Cosmic tous droits réservés | <NavLink activeClassName="selected" onClick={this.goTop} exact to="/mentions-legales">Mentions légales</NavLink></p>
              </div>
            </div>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}

export default Footer




// WEBPACK FOOTER //
// ./src/components/Footer.jsx